import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;
export const upcomingWorkVisitDateStyleId = 'upcoming-work-visit-date-theme';
export const upcomingWorkVisitDateBridgeStyles = {
  'wb-upcoming-work-visit-date': {
    '--local-upcoming-work-visit-date-gap': tokens.spacing.sm,
    '--local-upcoming-work-visit-date-text': tokens.color.text.secondary,
    '--local-upcoming-work-visit-date-background': tokens.color.background.secondary,
    '--local-upcoming-work-visit-date-border': tokens.color.border.secondary,
    '--local-upcoming-work-visit-date-blackout-text': tokens.color.text.warningPrimary,
    '--local-upcoming-work-visit-date-blackout-background': tokens.color.background.warningPrimary,
    '--local-upcoming-work-visit-date-blackout-border': tokens.componentColors.utility.warning300,
  },
};
